// Light leaf: enum + plain object maps for project detail tabs. Kept free of
// icon imports so the api/project barrel (re-exported from here) doesn't drag
// `@fortawesome/react-fontawesome` + dozens of `pro-regular-svg-icons` into
// the app shell. Heavy assets (projectTabIconMap, PROJECT_TABS,
// createFontAwesomeIcon) still live in tabs.tsx — consumers that need them
// deep-path `'api/project/tabs'`.
export var ProjectDetailTabKeys = /*#__PURE__*/ function(ProjectDetailTabKeys) {
    ProjectDetailTabKeys["AskAi"] = "AskAi";
    ProjectDetailTabKeys["Overview"] = "Overview";
    ProjectDetailTabKeys["FinancialsContainer"] = "FinancialsContainer";
    ProjectDetailTabKeys["Financials"] = "Financials";
    ProjectDetailTabKeys["Plan"] = "Plan";
    ProjectDetailTabKeys["SignalsV2"] = "SignalsV2";
    ProjectDetailTabKeys["MeetingPages"] = "MeetingPages";
    ProjectDetailTabKeys["EmailPages"] = "EmailPages";
    ProjectDetailTabKeys["Spaces"] = "Spaces";
    ProjectDetailTabKeys["NitroPages"] = "NitroPages";
    ProjectDetailTabKeys["Chat"] = "Chat";
    ProjectDetailTabKeys["TaskList"] = "TaskList";
    ProjectDetailTabKeys["TaskBoard"] = "TaskBoard";
    ProjectDetailTabKeys["StatusUpdate"] = "StatusUpdate";
    ProjectDetailTabKeys["FormResponses"] = "FormResponses";
    ProjectDetailTabKeys["Timesheet"] = "Timesheet";
    ProjectDetailTabKeys["Files"] = "Files";
    ProjectDetailTabKeys["ResourceManagement"] = "ResourceManagement";
    ProjectDetailTabKeys["ResourceRequest"] = "ResourceRequest";
    ProjectDetailTabKeys["ResourcePlan"] = "ResourcePlan";
    ProjectDetailTabKeys["CustomerPortalConfiguration"] = "CustomerPortalConfiguration";
    ProjectDetailTabKeys["Sheets"] = "Sheets";
    ProjectDetailTabKeys["Invoices"] = "Invoices";
    ProjectDetailTabKeys["Expense"] = "Expense";
    ProjectDetailTabKeys["ExpenseReport"] = "ExpenseReport";
    return ProjectDetailTabKeys;
}({});
export const tabApiEnumMap = {
    ["AskAi"]: 'askAi',
    ["Overview"]: 'overview',
    ["FinancialsContainer"]: 'financialsContainer',
    ["Financials"]: 'financials',
    ["SignalsV2"]: 'signalsV2',
    ["MeetingPages"]: 'meetingPages',
    ["EmailPages"]: 'emailPages',
    ["Plan"]: 'projectPlan',
    ["Spaces"]: 'spaces',
    ["NitroPages"]: 'nitroPages',
    ["Chat"]: 'chat',
    ["StatusUpdate"]: 'statusUpdates',
    ["TaskList"]: 'list',
    ["TaskBoard"]: 'board',
    ["FormResponses"]: 'form',
    ["Timesheet"]: 'timesheet',
    ["Files"]: 'files',
    ["ResourceManagement"]: 'resourceManagement',
    ["ResourceRequest"]: 'resourceRequest',
    ["ResourcePlan"]: 'resourcePlan',
    ["CustomerPortalConfiguration"]: 'customerportalconfiguration',
    ["Invoices"]: 'invoice',
    ["Expense"]: 'expense',
    ["ExpenseReport"]: 'expenseReport',
    ["Sheets"]: 'sheets'
};
export const tabParentChildMap = {
    ["ResourceManagement"]: [
        "ResourcePlan",
        "ResourceRequest"
    ],
    ["FinancialsContainer"]: [
        "Financials",
        "Timesheet",
        "Expense",
        "ExpenseReport",
        "Invoices"
    ]
};
export const childrenTabToParentMapping = Object.entries(tabParentChildMap).reduce((acc, [key, value])=>{
    const values = Array.isArray(value) ? value : [
        value
    ];
    return {
        ...acc,
        ...values.reduce((valueAcc, v)=>({
                ...valueAcc,
                [v]: key
            }), {})
    };
}, {});
export const CHILDREN_TABS = Object.values(tabParentChildMap).flat();
